import { render } from "./Suggestions.vue?vue&type=template&id=9a2d7986"
import script from "./Suggestions.vue?vue&type=script&lang=ts"
export * from "./Suggestions.vue?vue&type=script&lang=ts"

import "./Suggestions.vue?vue&type=style&index=0&id=9a2d7986&lang=scss"
script.render = render

export default script